import { ReactElement, useRef } from 'react'
import {
  CaseStudiesHero,
  CaseCardsSection,
  HireOlbySection,
  WebsiteLayout,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  WebsiteSeo,
} from '@platform/website-components'

const SEO = {
  title: 'Case studies // Olby',
  description:
    'Learn how Olby helped companies to scale their tech teams and achieve business goals: we can make an extraordinary future happen together.',
}

export const CaseStudies = () => {
  const caseStudiesRef = useRef<HTMLElement>(null)
  const caseCardsRef = useRef<HTMLElement>(null)
  const hireOlbyRef = useRef<HTMLElement>(null)

  useUpdateHeader(caseStudiesRef, HEADER_THEMES.EXT_BRAND_TEAL_ALT)
  useUpdateHeader(caseCardsRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(hireOlbyRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()
  return (
    <>
      <WebsiteSeo seo={SEO} />
      <CaseStudiesHero ref={caseStudiesRef} />
      <CaseCardsSection ref={caseCardsRef} />
      <HireOlbySection ref={hireOlbyRef} />
    </>
  )
}

export default CaseStudies

CaseStudies.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.EXT_BRAND_TEAL_ALT}>
      {page}
    </WebsiteLayout>
  )
}
